import { render, staticRenderFns } from "./SubGroupName.vue?vue&type=template&id=774d034d&scoped=true"
import script from "./SubGroupName.vue?vue&type=script&lang=js"
export * from "./SubGroupName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d034d",
  null
  
)

export default component.exports